import Header from './components/Header';
import Hero from "./components/Hero";
import Footer from "./components/Footer"
import './index.css';

function App() {
  return (
    <div>
      <Header/>
      <Hero />
      <Footer />
    </div>
  )
}

export default App;
